import styled from 'styled-components';
import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;

  box-shadow: 0px 6px 10px rgba(128, 98, 96, 0.16);
  border-radius: 12px;
  padding: 16px;
  margin: 16px 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Section = styled.div`
  flex: 1;
  display: flex;
  margin: 8px 0;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

export const Label = styled.span`
  font-size: 14px;
  line-height: 140%;
  color: #332927;
`;

export const Value = styled.span`
  font-size: 14px;
  line-height: 140%;
  color: #332927;
`;

export const Total = styled.span`
  font-size: 16px;
  line-height: 125%;
  font-weight: 600;
  color: #332927;
`;

export const TotalLabel = styled.span`
  font-size: 16px;
  line-height: 125%;
  font-weight: 600;
  color: #332927;
`;

export const Title = styled.h4`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.71;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.card.title};
`;

export const Header = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 10px;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.flightSector.color};
`;

export const Arrow = styled(Chevron)`
  width: 12px;
  height: 12px;
  padding: 0 2px;
  box-sizing: content-box;
  color: #626e75;
  transform: rotate(90deg);

  &.active {
    transform: rotate(270deg);
  }
`;

export const Division = styled.hr`
  height: 1px;
  margin: 16px 0;
  border: 0 none;
  color: ${({ theme }) => theme.flightDetails.price.division};
  background-color: ${({ theme }) => theme.flightDetails.price.division};
`;

export const PrivateFareMessage = styled.span`
  font-size: 12px;
  line-height: 1.33;
  text-align: right;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: 600;
`;

export const PrivateFareIconContainer = styled.div`
  height: 20px;
  width: 20px;
  margin-right: 5px;
`;